import React, { Component } from 'react'
import { mapValues, compact } from 'lodash'

import cn from 'classnames'
import s from './Markdown.scss'

import sText from 'components/Text/Text.scss'
import Button from 'components/Button'
import { CmsIcon } from '../Cms/CmsIcon'
import { Link } from 'react-router'
import markdownItAttrs from 'markdown-it-attrs'

import markdownIt from 'markdown-it'
import htmlToReact from 'html-to-react'
import IconTickCircle from 'components/Icons/TickCircle'

const htmlToReactParser = new htmlToReact.Parser()

export const md = markdownIt({
  html: true,
  linkify: false,
  typographer: true,
})

md.use(markdownItAttrs)

const addTruthyAttribs = obj => mapValues(obj, val => (val === '' ? true : val))
const addClassToAttribs = (node, classes) => {
  node.attribs.class = compact([
    node.attribs.class ? sText[node.attribs.class] : undefined,
    classes,
  ]).join(' ')
  return node
}

const addIconToChildren = (node, children) => {
  if (node.attribs.icon) {
    return [
      <CmsIcon
        name={node.attribs.icon}
        size={node.attribs['icon-size']}
        style={{ marginRight: '10px', verticalAlign: 'middle' }}
      />,
      children,
    ]
  }
  return children
}

export default class Markdown extends Component {
  getInstructions = () => [
    {
      shouldProcessNode: ({ name }) => name === 'h1',
      processNode: (node, children) =>
        new htmlToReact.ProcessNodeDefinitions(React).processDefaultNode(
          addClassToAttribs(node, sText.heading1),
          addIconToChildren(node, children)
        ),
    },
    {
      shouldProcessNode: ({ name }) => name === 'h2',
      processNode: (node, children) =>
        new htmlToReact.ProcessNodeDefinitions(React).processDefaultNode(
          addClassToAttribs(node, sText.heading2),
          addIconToChildren(node, children)
        ),
    },
    {
      shouldProcessNode: ({ name }) => name === 'h3',
      processNode: (node, children) =>
        new htmlToReact.ProcessNodeDefinitions(React).processDefaultNode(
          addClassToAttribs(node, sText.heading3),
          addIconToChildren(node, children)
        ),
    },
    {
      shouldProcessNode: ({ name }) => name === 'h4',
      processNode: (node, children) =>
        new htmlToReact.ProcessNodeDefinitions(React).processDefaultNode(
          addClassToAttribs(node, sText.heading4),
          addIconToChildren(node, children)
        ),
    },
    {
      shouldProcessNode: ({ name }) => name === 'h5',
      processNode: (node, children) =>
        new htmlToReact.ProcessNodeDefinitions(React).processDefaultNode(
          addClassToAttribs(node, sText.heading5),
          addIconToChildren(node, children)
        ),
    },
    {
      shouldProcessNode: ({ name }) => ['p', 'ul', 'ol'].includes(name),
      processNode: (node, children) =>
        new htmlToReact.ProcessNodeDefinitions(React).processDefaultNode(
          addClassToAttribs(node, sText.descrip2),
          addIconToChildren(node, children)
        ),
    },
    {
      shouldProcessNode: ({ name }) => ['li'].includes(name),
      processNode: (node, children) =>
        new htmlToReact.ProcessNodeDefinitions(React).processDefaultNode(
          addClassToAttribs(node, sText.descrip2),
          [
            <IconTickCircle
              className={sText.accent}
              size={30}
              style={{ marginLeft: '-40px', marginRight: '10px' }}
            />,
            children,
          ]
        ),
    },
    {
      shouldProcessNode: ({ name }) => name === 'button',
      processNode: (node, children) => (
        <Button {...addTruthyAttribs(node.attribs)} className={s.button}>
          {children}
        </Button>
      ),
    },
    {
      shouldProcessNode: ({ name }) => name === 'a',
      processNode: (node, children) =>
        node.attribs.href.startsWith('http') ? (
          <a {...node.attribs}>{children}</a>
        ) : (
          <Link to={node.attribs.href}>{children}</Link>
        ),
    },
    {
      shouldProcessNode: () => true,
      processNode: new htmlToReact.ProcessNodeDefinitions(React).processDefaultNode,
    },
  ]
  getHtml = value => {
    const html = md.render(value || '')
    const wrappedHtml = `<div>${html}</div>`
    return htmlToReactParser.parseWithInstructions(wrappedHtml, () => true, this.getInstructions())
  }
  render() {
    const { text, className, color, ...otherProps } = this.props
    return (
      <div className={cn(s.display, className)} {...otherProps}>
        {this.getHtml(text)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Markdown/Markdown.jsx